import styled from 'styled-components';

const NewLabel = styled.div`
	position: absolute;
	font-weight: bold;
	color: white;
	top: 0px;
	left: 0px;
	display: flex;
	width: 50%;
	height: 70%;
	box-shadow: -4px -4px 5px 0 rgba(0, 0, 0, 0.6);
	background: linear-gradient(
		to top left,
		transparent 5%,
		transparent 50%,
		transparent 50%,
		var(--color-mid-pink) 0
	);

	& span {
		margin: 10% 0 0 10%;
		font-size: 10px;
	}
`;

export default NewLabel;
// File renamed to src/features/documents/components/NewLabel.tsx
